import classNames from 'classnames';
import { ReactNode } from 'react';
import { Heading } from 'yoso';
import { BaseCard, BaseCardProps } from '~/components/Card';
import styles from './GuideCard.module.scss';

export type GuideCardProps = {
  title: ReactNode;
  description?: ReactNode;
  image: ReactNode;
} & Omit<BaseCardProps, 'title'>;
export const GuideCard = ({
  title,
  description,
  image,
  children,
  className,
  size = 'large',
  ...props
}: GuideCardProps) => (
  <BaseCard className={classNames(styles.root, className)} size={size} {...props}>
    <div className={styles.header}>
      {typeof image === 'string' ? <img src={image} alt="icon" width={176} height={176} /> : image}
    </div>
    <div className={styles.body}>
      <Heading className={styles.title}>{title}</Heading>
      {description && <p className={styles.description}>{description}</p>}
      {children}
    </div>
  </BaseCard>
);
